<template>
	<v-app-bar app color="primary" dark flat>
		<v-app-bar-nav-icon v-if="$vuetify.breakpoint.mdAndDown" @click="toggleMobileNav"></v-app-bar-nav-icon>
		<div class="mr-16">
			<router-link :to="homeRoute" class="logo-link d-flex align-center">
				<img src="/assets/images/logo-brainlab.svg" height="21" alt="" />
				<span class="novalis-logo-text">Cranial <span class="d-none d-md-inline">Neurosurgery</span> Symposium</span>
			</router-link>
		</div>
		<nav v-if="$vuetify.breakpoint.lgAndUp">
			<v-list color="primary" class="d-flex">
				<v-list-item :to="homeRoute" exact :ripple="false">
					<v-list-item-title>Welcome</v-list-item-title>
				</v-list-item>
				<v-list-item :to="eventUrl + 'registration'" :ripple="false">
					<v-list-item-title>Registration</v-list-item-title>
				</v-list-item>
				<v-list-item :to="eventUrl + 'program'" :ripple="false">
					<v-list-item-title>Program</v-list-item-title>
				</v-list-item>
				<v-list-item :to="eventUrl + 'social-gathering'" :ripple="false">
					<v-list-item-title>Social Gathering</v-list-item-title>
				</v-list-item>
				<v-list-item :to="eventUrl + 'travel'" :ripple="false">
					<v-list-item-title>Travel</v-list-item-title>
				</v-list-item>
				<v-list-item :to="eventUrl + 'faq'" :ripple="false">
					<v-list-item-title>FAQ & Contact</v-list-item-title>
				</v-list-item>
			</v-list>
		</nav>
	</v-app-bar>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'header-cranial-symposium',
	computed: {
		...mapState(['language']),
		homeRoute() {
			return this.language === 'en' ? `${this.eventUrl}` : `${this.eventUrl}${this.language}`
		},
	},
	data: () => ({
		eventUrl: '/events/cranial-symposium/',
	}),
	methods: {
		toggleMobileNav() {
			this.$store.commit('toggleMobileNav')
		},
	},
}
</script>

<style>
.logo-link {
	line-height: 1;
}

nav .theme--dark.v-list-item--active:hover::before,
nav .theme--dark.v-list-item--active::before,
nav .theme--dark.v-list-item:hover::before {
	opacity: 0 !important;
}
nav .theme--dark.v-list-item:hover {
	text-decoration: underline;
	color: rgba(255, 255, 255, 0.8) !important;
}
</style>
